import { onUnmounted, ref, watch } from '@vue/composition-api'
import store from '@/store'
import logStoreModule from './logStoreModule'


export default function useActivityLog() {


  const LOG_STORE_MODULE_NAME = 'log'

  // Register module
  if (!store.hasModule(LOG_STORE_MODULE_NAME))
    store.registerModule(LOG_STORE_MODULE_NAME, logStoreModule)

  // UnRegister on leave
  onUnmounted(() => {
    if (store.hasModule(LOG_STORE_MODULE_NAME))
      store.unregisterModule(LOG_STORE_MODULE_NAME)
  })

  const requestStatus = ref(false)

 


  const causerOptions = ref([])
  const subjectOptions=ref([])
  const eventOptions=ref([])
  const nameOptions = ref([])

  const perPageOptions = [5, 10, 15, 20, 50, 100]


  // get filters
  store.dispatch('log/fetchLogFilters').then(r => {
    
 
  
    

 
    //subjectOptions.value=reFormatSubjectoptions(r.data.data.subject)
    subjectOptions.value=r.data.data.subject
    causerOptions.value=r.data.data.causer
    eventOptions.value=r.data.data.event
    //nameOptions.value = r.data.data.name

  }).catch(reason => console.log(reason))


  const reFormatSubjectoptions=(items)=>{

    //console.log('ddddddddddddddd',items);

   return  items.map((item,index)=>({id:index,name:item.name,subject_id:item.subject_id}));
    
  }

  const logs = ref([])
  const total = ref(0)
  const currentPage = ref(1)
  const perPage = ref(10)


 
  
  const searchQuery = ref('')
 
  const subjectFilter=ref(null)
  const  causerFilter=ref(null)
  const eventFilter=ref(null)
  const nameFilter = ref(null)
  const    from=ref(null)
  const to=ref(null)

  const filter = ref({})

  watch([currentPage, perPage, subjectFilter,causerFilter,eventFilter, nameFilter,from,to ], () => {

    filter.value = {
    
      ...(subjectFilter.value && { subjects: subjectFilter.value }),
      ...(causerFilter.value && { causers: causerFilter.value }),
      ...(eventFilter.value && { events: eventFilter.value }),
      ...(from.value && { from: from.value }),
      ...(to.value && { to: to.value }),
    
      ...(searchQuery.value && {q: searchQuery.value})
    }

    fetchLog()
  })


  const fetchLog = () => {
 
    requestStatus.value = true
    store.dispatch('log/fetchLog', {
      length: perPage.value,
      page: currentPage.value,
      ...filter.value
    }).then(res => {
    
      requestStatus.value = false
      logs.value = res.data.data
      total.value =res.data.total
      perPage.value = res.data.per_page
      currentPage.value =res.data.current_page
      
    })
  }


  return {
    logs,
    total,
    currentPage,
    perPage,
    fetchLog,
   
   
   
    

    subjectOptions,
    subjectFilter,

    causerOptions,
    causerFilter,

    eventOptions,
    eventFilter,

    requestStatus,
 

    nameOptions,
    nameFilter,
    perPageOptions,
    from,to
  }
}
